import { useState } from 'react';
import { Link } from 'react-router-dom';

interface MobileProductCTABarProps {
  productName: string;
  quoteHref?: string;
  quoteLabel?: string;
}

export default function MobileProductCTABar({
  productName,
  quoteHref = '/instant-quote',
  quoteLabel = 'Get Instant Quote',
}: MobileProductCTABarProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const isExternal = quoteHref.startsWith('http') || quoteHref.startsWith('tel');

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 safe-area-pb">
      {/* Dismiss handle */}
      <div className="flex justify-center pt-1 bg-transparent pointer-events-none">
        <div className="w-10 h-1 bg-gray-300 rounded-full" />
      </div>

      <div className="bg-white border-t border-gray-200 px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.12)]">
        {/* Label row */}
        <div className="flex items-center justify-between mb-2.5">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-fill text-[#D97642] text-base" />
            <span className="text-xs font-semibold text-[#1A3A52] leading-tight">
              {productName}
            </span>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
            aria-label="Dismiss"
          >
            <i className="ri-close-line text-base" />
          </button>
        </div>

        {/* Buttons row */}
        <div className="flex gap-2">
          {isExternal ? (
            <a
              href={quoteHref}
              className="flex-1 flex items-center justify-center gap-1.5 py-3 bg-[#D97642] text-white text-sm font-bold rounded-lg whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base" />
              {quoteLabel}
            </a>
          ) : (
            <Link
              to={quoteHref}
              className="flex-1 flex items-center justify-center gap-1.5 py-3 bg-[#D97642] text-white text-sm font-bold rounded-lg whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base" />
              {quoteLabel}
            </Link>
          )}
          <a
            href="tel:3176482983"
            className="flex items-center justify-center gap-1.5 px-4 py-3 bg-[#1A3A52] text-white text-sm font-bold rounded-lg whitespace-nowrap"
          >
            <i className="ri-phone-fill text-base" />
            Call
          </a>
        </div>

        {/* Trust micro-copy */}
        <p className="text-center text-[10px] text-gray-400 mt-2 leading-tight">
          Free quote · No exam required · Response in 24 hrs
        </p>
      </div>
    </div>
  );
}
